import { Box, Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import { useHomePage } from "./hooks/useHomePage";
import WidgetWrapper from "components/WidgetWrapper";
import Header from "components/Header";
import FlexBetween from "components/FlexBetween";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import ProductForm from "components/ProductForm";
import ProductEmissionsGrid from "scenes/ProductEmissionsGrid";

function HomePage() {
  const {
    isLargeScreen,
    open,
    editMode,
    currentProduct,
    handleOpen,
    handleEditOpen,
    handleClose,
    setOpen,
  } = useHomePage();

  return (
    <Box m={isLargeScreen ? "1rem" : "1.5rem 0.5rem 2rem 0.5rem"}>
      <WidgetWrapper>
        <FlexBetween>
          <Header
            title="Welcome to Deovise"
            subtitle="Understand more about your food"
          />
          <Button
            variant="contained"
            color="primary"
            sx={{
              borderRadius: "5px",
              fontSize: "12px",
              padding: "5px 10px",
            }}
            onClick={handleOpen}
          >
            <DriveFileRenameOutlineOutlinedIcon sx={{ mr: "0.5rem" }} />
            Add new Product
          </Button>
        </FlexBetween>
        <ProductEmissionsGrid handleEditOpen={handleEditOpen} />

        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
          <DialogTitle>{editMode ? "Edit Product" : "Add Product"}</DialogTitle>
          <DialogContent>
            <ProductForm
              editMode={editMode}
              setOpen={setOpen}
              currentProduct={currentProduct}
            />
          </DialogContent>
        </Dialog>
      </WidgetWrapper>
    </Box>
  );
}

export default HomePage;
